// extracted by mini-css-extract-plugin
module.exports = {"DataOptions":"dataOptions_DataOptions__1Kwkd"};